export const seriesData1 = [
  { data: [40, 30, 20, 27, 18, 23, 34, 20, 27, 18, 23, 34], label: "uv" },
];

export const seriesData2 = [
  { data: [24, 13, 98, 39, 48, 38, 43, 20, 27, 18, 23, 34], label: "pv" },
];

export const seriesData3 = [
  { data: [15, 25, 35, 45, 55, 65, 75, 85, 95, 100, 110, 120], label: "wv" },
];

export const seriesData4 = [
  { data: [10, 20, 30, 40, 50, 60, 70, 80, 90, 95, 105, 115], label: "xv" },
];

export const seriesData5 = [
  { data: [5, 15, 25, 35, 45, 55, 65, 75, 85, 90, 95, 105], label: "yv" },
];

export const xLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const infoCardData = [
  { label: "Subscribers", value: "126,258" },
  { label: "New Subscribers", value: "126" },
  { label: "Completed Plans", value: "5,267" },
  { label: "Monthly Exercises", value: "18,870" },
  { label: "Hours in App", value: "5,876" },
];

export const chartData = [
  { title: "Monthly Active Users", series: seriesData1 },
  { title: "Active Trainees", series: seriesData2 },
  { title: "Total Subscribers", series: seriesData3 },
  { title: "Total Training Sessions ", series: seriesData4 },
  { title: "Completed Plans", series: seriesData5 },
];
